import { SxProps } from '@mui/material';

const inputFontSize = {
  sm: '2.5rem',
  xs: '1.5rem'
};
const styles: Record<string, SxProps> = {
  root: {
    '& .MuiInput-underline': {
      height: {
        sm: '4rem',
        xs: '3rem'
      },
      '& input': {
        fontSize: inputFontSize
      },
      '& .MuiInputAdornment-root': {
        margin: 0,
        '& .MuiTypography-root': {
          fontSize: inputFontSize
        }
      }
    }
  }
};

export default styles;
